import * as React from "react";
import { match } from 'react-router';
import { Col } from 'reactstrap';
import { isNull } from "lodash";
import { GAActiveUsers } from "./components/GAActiveUsers";
import { GACountries } from '../../share/components/GoogleAnalitycs/GACountries';
import { GAPageViews } from '../../share/components/GoogleAnalitycs/GAPageViews';
import { GAWeeksComparison } from '../../share/components/GoogleAnalitycs/GAWeeksComparison';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { GABrowsers } from '../../share/components/GoogleAnalitycs/GABrowsers';
import { useGAToken } from './hooks/useGAToken';
import environmentHelper from "src/share/utils/environmentHelper";
import routes from "../Routing/routes";
import { useGAPageViews } from "src/share/components/GoogleAnalitycs/hooks/useGAPageViews";
import { useGoogleInit } from "src/share/hooks/useGoogleInit";
import './googleStatistics.css';
import { RoutesModules } from "src/modules/Routing/types";

export interface IGoogleStatisticsProps {
  match: match;
}

export interface IGoogleStatisticView {
  query: {
    ids: string;
  }
}

const GoogleStatistics: React.SFC<IGoogleStatisticsProps> = (props) => {
  const [initialDaysAgo] = React.useState<number>(30);
  const [view, setView] = React.useState<IGoogleStatisticView>(environmentHelper.getGMCNgineGAView());
  const { token } = useGAToken();
  React.useEffect(() => {
    const isFind = props.match.path === routes.FINDSTATS;
    if (isFind) {
      setView(environmentHelper.getFindGAView())
    } else {
      setView(environmentHelper.getGMCNgineGAView())
    }
  }, [props.match.path]);
  const [ready] = useGoogleInit(token);
  const { pageViews } = useGAPageViews({ daysAgo: initialDaysAgo, ready, views: view });
  return (
    <div className="providers">
      {ready &&
        <div className={'stats gstats'}>
          <div className="margin-big-card half-cards row">
            <Col className="col-12 no-padding-left">
              <GAActiveUsers views={view} />
            </Col>
          </div>
          <div className="margin-big-card half-cards row">
            <Col className="col-12 no-padding-left">
              {!isNull(pageViews) &&
                <GAPageViews daysAgo={initialDaysAgo} pageViews={pageViews} />}
            </Col>
          </div>
          <div className="margin-big-card half-cards row">
            <Col className="col-12 no-padding-left">
              <GAWeeksComparison views={view} />
            </Col>
          </div>
          <div className="margin-big-card half-cards row">
            <Col className="col-md-6 col-12 no-padding-left col">
              <GACountries views={view} />
            </Col>
            <Col className="col-md-6 col-12 no-padding-left col">
              <GABrowsers views={view} />
            </Col>
          </div>
        </div>}
    </div>
  )
}

export default SidebarContainer(RoutesModules.ADMIN)(GoogleStatistics);



// WEBPACK FOOTER //
// ./src/modules/GoogleStatistics/GoogleStatistics.tsx